import type { MouseEvent, ReactNode } from 'react';
import { Icon, type IconName } from './Icon.js';
import { cx } from './cx.js';

/** Barre de contrôle du campus (micro, caméra, écran | chat, personnes | réagir). */
export function ControlBar({ label = 'Contrôles du campus', children }: { label?: string; children?: ReactNode }) {
  return <div className="pl-controlbar" role="toolbar" aria-label={label}>{children}</div>;
}

/**
 * Bouton de la barre de contrôle. `off` pour un média coupé, `active` pour un
 * panneau ouvert, `badge` pour signaler du nouveau (point rouge).
 * La légende suit l'état réel (« Caméra » + off, pas « Cam off »).
 * `expanded` : le bouton ouvre un menu (le menu ne se referme pas au clic sur lui, voir Menu).
 */
export function ControlButton({ icon, label, active, off, speaking, badge, disabled, title, expanded, onClick }: {
  icon: IconName;
  label: string;
  active?: boolean;
  off?: boolean;
  /** Micro : la voix est captée (anneau vert qui pulse). */
  speaking?: boolean;
  /** Pastille : point rouge (true) ou nombre de non-lus. */
  badge?: boolean | number;
  disabled?: boolean;
  title?: string;
  expanded?: boolean;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}) {
  return (
    <button
      type="button"
      className={cx('pl-ctl', active && 'pl-ctl-active', off && 'pl-ctl-off', speaking && 'pl-ctl-speaking')}
      aria-pressed={expanded === undefined ? active ?? undefined : undefined}
      aria-expanded={expanded}
      disabled={disabled}
      title={title}
      onClick={onClick}
    >
      <Icon name={icon} size={18} />
      <span className="pl-ctl-label">{label}</span>
      {typeof badge === 'number' && badge > 0
        ? <span className="pl-ctl-badge pl-ctl-badge-count" aria-label={`${badge} non lu${badge > 1 ? 's' : ''}`}>{badge > 9 ? '9+' : badge}</span>
        : badge === true && <span className="pl-ctl-badge" aria-label="Nouveau" />}
    </button>
  );
}

export function ControlDivider() {
  return <span className="pl-ctl-divider" aria-hidden="true" />;
}
